export default __webpack_public_path__ + "static/N0282-faeb6110754ca7e3872814c902aa36bc.png";